export default "__VITE_ASSET__CE7Ke_Fp__"